"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const card_1 = require("./card");
const lodash_1 = require("lodash");
function resolveActionability(myHand, table, discardPile) {
    // make a copy to prevent modifying the argument
    myHand = myHand.map(mc => new card_1.MaskedCard(mc.toJSON()));
    function resolveOne(value) {
        const card = new card_1.Card(value);
        if (table.isPlayable(card))
            return 'PLAYABLE';
        if (table.has(card))
            return 'DISCARDABLE';
        else {
            // Maybe the card can never be played because all lower (black:higher) cards have been discarded.
            const notPlayedYetNumbers = card.color === 'K' ? lodash_1.range(card.num + 1, 5 + 1) : lodash_1.range(1, card.num);
            if (notPlayedYetNumbers.some(num => discardPile.cards.filter(c => c.color === card.color && c.num === num).length ===
                card_1.getNumDistribution(card.color).filter(n => n === num).length))
                return 'DISCARDABLE';
            // The card has not been played yet. Maybe the card is unique, thus not discardable.
            if (discardPile.cards.filter(c => c.equals(card)).length ===
                card_1.getNumDistribution(card.color).filter(n => n === card.num).length - 1)
                return 'UNDISCARDABLE';
        }
        // cannot be played yet, but is not discardable.
        return 'UNPLAYABLE';
    }
    // const unrevealedCards = Card.getFullDeck()
    // for (const r of revealedCards) {
    //   unrevealedCards.splice(
    //     unrevealedCards.findIndex(u => u.equals(r)),
    //     1,
    //   )
    // }
    for (const mc of myHand) {
        if (mc.value) {
            // We know this card, so let's resolve the actionability.
            mc.actionability = resolveOne(mc.value);
        }
        else if (mc.possibleCards) {
            // We have some ideas what the card could be. Resolve actionability of each possible card.
            for (const pc of mc.possibleCards) {
                pc.actionability = resolveOne(pc.value);
            }
            // If all possible cards have the same actionability, report it as
            // the actionability of the card itself and not of the possibleCards.
            if (mc.possibleCards.every(pc => pc.actionability === mc.possibleCards[0].actionability)) {
                mc.actionability = mc.possibleCards[0].actionability;
                mc.possibleCards.forEach(pc => delete pc.actionability);
            }
        }
    }
    return myHand;
}
exports.resolveActionability = resolveActionability;
function resolveActionabilityD(...args) {
    console.warn('CALLING', ...args);
    const ret = resolveActionability.apply(null, args);
    console.warn('RETURNING', ret);
    return ret;
}
exports.resolveActionabilityD = resolveActionabilityD;
//# sourceMappingURL=actionability-resolver.js.map